import React from "react";
import propTypes from "prop-types";

export default class ReportsDownloadForm extends React.Component {
  static propTypes = {
    index: propTypes.number.isRequired,
    filmName: propTypes.string.isRequired,
    schedule: propTypes.any.isRequired,
    amount: propTypes.number.isRequired,
    money: propTypes.number.isRequired
  };

  render() {
    const { index, filmName, schedule, amount, money } = this.props;
    return (
      <div key={index}>
        <input className="large-column" defaultValue={filmName} />
        <input className="small-column gray" defaultValue={schedule} />
        <input className="small-column" defaultValue={amount} />
        <input className="small-column" defaultValue={money} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ReportsDownloadForm.jsx